export function get(user, flag) {
  if (!user.flags) {
    // For backwards compatibility with login sessions before the release of flags, disable everything if there are none.
    return false;
  }

  return user.flags[flag];
}

export function isOn(user, flag) {
  return get(user, flag);
}

export function isOff(user, flag) {
  return !isOn(user, flag);
}